import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Outlet } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Products from './components/Products';
import ImageSection from './components/ImageSection';
import WhyUs from './components/WhyUs';
import Brands from './components/Brands';
import FAQ from './components/FAQ';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import RefundPolicy from './pages/RefundPolicy';
import ContactUs from './pages/ContactUs';
import HomeClonePage from './pages/HomeClonePage';
import FloatingPhoneCTA from './components/FloatingPhoneCTA';
import { QuoteModalProvider } from './context/QuoteModalContext';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const HomePage = () => (
  <>
    <Hero />
    <Features />
    <Products />
    <ImageSection />
    <WhyUs />
    <Brands />
    <FAQ />
    <Testimonials />
    <CTA />
  </>
);

const MainLayout = () => (
  <QuoteModalProvider>
    <div className="App">
      <Navbar />
      <Outlet />
      <Footer />
      <FloatingPhoneCTA />
    </div>
  </QuoteModalProvider>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/auto" element={<HomeClonePage />} />
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/terms-and-conditions" element={<TermsOfService />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/contact-us" element={<ContactUs />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
